import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'team';

export default {
  state: {
    currentTeam: {
      id: null,
      name: "",
      fallback_category_id: null,
      settings: {}
    }
  },

  mutations: {
    setCurrentTeam(state, team) {
      state.currentTeam = team;
    },

    updateFallbackId(state, id) {
      state.currentTeam.fallback_category_id = id;
    },

    updateContainsTimeId(state, id) {
      state.currentTeam.settings.contains_time_category_id = String(id);
    }
  },

  actions: {
    fetchCurrentTeam({ commit, dispatch }) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params: { team_id: auth.teamId() } })
        .then((resp) => {
          commit("setCurrentTeam", resp.data.data.attributes);

          // Connect realtime messaging for conversations
          dispatch("connectRealtimeMessages", resp.data.data.attributes.id);
          dispatch("connectRealtimeWebhooks", resp.data.data.attributes.id);
        })
        .catch((err) => {
          console.error("error loading current team", err);
        });
    },

    updateTeamFallbackCategoryId({ commit }, categoryId) {
      commit("updateFallbackId", categoryId);
    },

    updateTeamContainsTimeCategoryId({ commit }, categoryId) {
      commit("updateContainsTimeId", categoryId);
    }
  },

  getters: {
    currentTeam: (state) => state.currentTeam
  }
};
